import React, { useState } from 'react';
import { Button, TextField } from '@mui/material';
import { useMediaGalleryPageContext } from 'pages/MediaGalleryPage/media-gallery-page.context';
import styled from 'styled-components';

const StyledTextField = styled(TextField)`
  flex-grow: 1;
  padding-right: 1rem;

  ${(props) => `
    fieldset {
      border-color: ${props.theme.colors.neutral200};
    }

    input {
      padding: 0.5rem 1rem;
      color: ${props.theme.colors.neutral200}
    }
  `}
`;

const StyledButton = styled(Button)<{ $disabled?: boolean }>`
  ${(props) =>
    props.$disabled &&
    `
    &&& {
      color: #8f8f8f;
      border-color: #8f8f8f;
    }
  `}

  color: ${(props) => props.theme.colors.neutral200};
`;

const MediaCommentInput = ({ id }: { id?: number }) => {
  const { addMediaComment } = useMediaGalleryPageContext();
  const [commentInput, setCommentInput] = useState('');

  const handleAddComment = async () => {
    await addMediaComment({
      mediaId: id!,
      body: commentInput,
    });
    setCommentInput('');
  };

  return (
    <>
      <StyledTextField
        type='text'
        value={commentInput}
        onChange={(e) => setCommentInput(e.target.value)}
        placeholder='Write a comment'
        onKeyDown={(e) => {
          if (e.code === 'Enter') handleAddComment();
        }}
      />
      <StyledButton
        disabled={!commentInput.length}
        $disabled={!commentInput.length}
        onClick={handleAddComment}
      >
        Post
      </StyledButton>
    </>
  );
};

export default MediaCommentInput;
